import { useCallback } from 'react';

import {
  useTableState,
  useTableDispatch,
} from '../context/TableSchemaBuilderContext';
import { parseCellId } from '../utils/cellHelpers';

export const useTableClipboard = () => {
  const { schema, ui } = useTableState();
  const dispatch = useTableDispatch();

  const handleCopy = useCallback(() => {
    const copiedData = ui.selectedCells?.map((cellId) => ({
      cellId,
      value: schema?.cells?.[cellId]?.value ?? '',
    }));

    dispatch({
      type: 'SET_CLIPBOARD',
      payload: copiedData,
    });
  }, [schema?.cells, ui.selectedCells, dispatch]);

  const handlePaste = useCallback(() => {
    if (!ui.clipboard || !ui.selectedCells?.length) {
      return;
    }

    const [startCol, startRow] = parseCellId(ui.selectedCells[0]);
    const pasteData = {};

    ui.clipboard.forEach(({ value }, index) => {
      const [colOffset, rowOffset] = parseCellId(ui.clipboard[index].cellId);
      const targetCol =
        startCol + (colOffset - parseCellId(ui.clipboard[0].cellId)[0]);
      const targetRow =
        startRow + (rowOffset - parseCellId(ui.clipboard[0].cellId)[1]);
      const targetCell = `${String.fromCharCode(64 + targetCol)}${targetRow}`;

      if (targetCol <= schema?.columns && targetRow <= schema?.rows) {
        pasteData[targetCell] = { value };
      }
    });

    dispatch({
      type: 'PASTE_CELLS',
      payload: pasteData,
    });
  }, [ui.clipboard, ui.selectedCells, schema?.rows, schema?.columns, dispatch]);

  return { handleCopy, handlePaste };
};
